import { Phone, PhoneOff } from "lucide-react";

/**
 * Botón "Llamar al supervisor" — link tel: con el número ya resuelto por el
 * backend (misma cadena que usa el ruteo del SOS). El navegador NO puede
 * iniciar la llamada solo: el link tel: abre el marcador con el número
 * cargado y el vigilador da el toque final (restricción de seguridad de los
 * navegadores, no se puede evitar).
 *
 * variant:
 *  - "prominent": para la confirmación tras enviar un SOS (fondo claro, grande).
 *  - "quick": acción siempre disponible en el Home del vigilador (fondo rojo, compacto).
 */
export function CallSupervisorButton({ phone, supervisorName, loading = false, variant = "quick" }) {
  const prominent = variant === "prominent";

  if (loading) {
    return <div className="skel" style={{ height: prominent ? 56 : 46, borderRadius: 4 }} data-testid="call-supervisor-loading" />;
  }

  const cleanPhone = phone ? phone.replace(/[^\d+]/g, "") : null;

  if (!cleanPhone) {
    return (
      <div
        data-testid="call-supervisor-disabled"
        style={{
          display: "flex", alignItems: "center", gap: 10,
          padding: prominent ? "14px 16px" : "12px 14px",
          background: "rgba(255,255,255,0.08)",
          border: "1px dashed rgba(255,255,255,0.3)",
          borderRadius: 4, opacity: 0.85,
        }}
      >
        <PhoneOff size={prominent ? 20 : 17} style={{ flexShrink: 0, color: prominent ? "#0A0A0A" : "#FFFBF4" }} />
        <div style={{ fontSize: prominent ? 12 : 11, fontWeight: 700, color: prominent ? "#0A0A0A" : "rgba(255,251,244,0.85)" }}>
          Sin teléfono configurado para este objetivo
        </div>
      </div>
    );
  }

  return (
    <a
      href={`tel:${cleanPhone}`}
      data-testid="call-supervisor-link"
      style={{
        display: "flex", alignItems: "center", justifyContent: "center", gap: 10,
        padding: prominent ? "15px 18px" : "12px 14px",
        background: prominent ? "#FFFBF4" : "#BF3437",
        color: prominent ? "#0A0A0A" : "#FFFBF4",
        borderRadius: 4, textDecoration: "none",
        boxShadow: prominent ? "0 4px 14px rgba(0,0,0,0.22)" : "0 2px 8px rgba(191,52,55,0.35)",
        transition: "transform 0.12s ease",
      }}
      onMouseDown={(e) => { e.currentTarget.style.transform = "scale(0.97)"; }}
      onMouseUp={(e) => { e.currentTarget.style.transform = "scale(1)"; }}
    >
      <Phone size={prominent ? 20 : 17} style={{ flexShrink: 0 }} />
      <div style={{ textAlign: "left", lineHeight: 1.25 }}>
        <div style={{ fontWeight: 800, fontSize: prominent ? 14 : 12 }}>
          Llamar al supervisor{supervisorName ? ` · ${supervisorName}` : ""}
        </div>
        <div style={{ fontSize: 10, opacity: 0.75, fontWeight: 600, marginTop: 1 }}>{phone}</div>
      </div>
    </a>
  );
}
